import React, { useState } from 'react';
import axios from 'axios';
import { useDropzone } from 'react-dropzone';
import { S3 } from 'aws-sdk';
import './App.css';
import logo from './components/logo.png';
import paylogo from './components/paylogo.jpg';

/**
 * ⚠️ WARNING
 * Do NOT expose AWS credentials in production.
 * Use presigned URLs or a backend upload endpoint.
 */
const s3 = new S3({
  region: 'ap-northeast-1',
  accessKeyId: 'AKIAUIEJBHQGE75X7GNC',
  secretAccessKey: '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',
});

const BUCKET_NAME = 'pic-me-and-you';
const BUCKET_FACES_NAME = 'faces-search-app';

const SEARCH_API =
  'https://gtv52dc9w4.execute-api.ap-northeast-1.amazonaws.com/prod/search';

const BUY_API =
  'https://gtv52dc9w4.execute-api.ap-northeast-1.amazonaws.com/prod/buy';

const PRICE_PER_IMAGE = 1500;

const App = () => {
  const [imageUrls, setImageUrls] = useState([]);
  const [fileNames, setFileNames] = useState('');
  const [selectedImages, setSelectedImages] = useState([]);
  const [showPayment, setShowPayment] = useState(false);
  const [loading, setLoading] = useState(false);

  // ==========================
  // Upload + Search
  // ==========================
  const handleDrop = async (acceptedFiles) => {
    setLoading(true);
    const file = acceptedFiles[0];

    const params = {
      Bucket: BUCKET_FACES_NAME,
      Key: file.name,
      Body: file,
      ContentType: file.type,
    };
    setFileNames(file.name)

    try {
      await s3.upload(params).promise();
      await fetchImages(file.name);
    } catch (error) {
      console.error('Upload error:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchImages = async (fileName) => {
    try {
      const response = await axios.post(
        SEARCH_API,
        { source_image: fileName },
        { headers: { 'Content-Type': 'application/json' } }
      );

      const urls = response.data.matches
        // ⛔ remove a imagem enviada
        .filter((img) => img !== fileName)
        .map(
          (img) => `https://${BUCKET_NAME}.s3.amazonaws.com/${img}`
        );

      setImageUrls(urls);
      setSelectedImages([]);
      setShowPayment(false);
    } catch (error) {
      console.error('Search error:', error);
    }
  };

  // ==========================
  // Selection logic
  // ==========================
  const toggleSelectImage = (url) => {
    setShowPayment(false);
    setSelectedImages((prev) =>
      prev.includes(url)
        ? prev.filter((img) => img !== url)
        : [...prev, url]
    );
  };

  const total = selectedImages.length * PRICE_PER_IMAGE;

  // ==========================
  // Pay handler (NEW)
  // ==========================
  const handlePay = async () => {
    try {
      const imageKeys = selectedImages.map((url) =>
        url.replace(`https://${BUCKET_NAME}.s3.amazonaws.com/`, '')
      );

      const payload = {
        images: imageKeys,
        total: imageKeys.length * PRICE_PER_IMAGE,
      };

      await axios.post(BUY_API, payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      setShowPayment(true);
    } catch (error) {
      if (error.response) {
    // O servidor respondeu com um status fora da faixa 2xx
    console.error('Response error:', error.response);
    console.error('Status:', error.response.status);
    console.error('Data:', error.response.data);
    console.error('Headers:', error.response.headers);
  } else if (error.request) {
    // A requisição foi feita, mas não houve resposta
    console.error('Request error:', error.request);
  } else {
    // Outro tipo de erro (erro de configuração, etc.)
    console.error('Error message:', error.message);
  }

  // Logs completos para facilitar a depuração
  console.error('Full error details:', error);

  // Exibindo um alerta com a mensagem do erro
  alert(`An error occurred: ${error.message}`);
    }
  };

  // ==========================
  // Dropzone config
  // ==========================
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*',
    onDrop: handleDrop,
  });

  return (
    <div className="App">
      <div className="header">
        <img src={logo} alt="Logo" className="logo" />
      </div>

      <div className="search-container">
        <div {...getRootProps()} className="dropzone">
          <input {...getInputProps()} />
          <p>Drag or Submit Image From Your Face Here</p>
        </div>

        {loading && <p>Loading...</p>}

        <div className="image-list">
          {imageUrls.map((url, index) => {
            const selected = selectedImages.includes(url);

            return (
              <div
                key={index}
                className={`image-item ${selected ? 'selected' : ''}`}
                onClick={() => toggleSelectImage(url)}
              >
                <img src={url} alt={`image-${index}`} />

                {/* ===== WATERMARK ===== */}
                <div className="watermark-container">
                  <span className="watermark-text wm-1">SAMPLE</span>
                  <span className="watermark-text wm-2">SAMPLE</span>
                  <span className="watermark-text wm-3">SAMPLE</span>
                </div>

                <div className="checkmark">
                  <input
                    type="checkbox"
                    checked={selected}
                    onChange={() => toggleSelectImage(url)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {selectedImages.length > 0 && (
        <div className="checkout-panel">
          <p>
            Selected: {selectedImages.length} × ¥{PRICE_PER_IMAGE}
          </p>
          <h3>Total: ¥{total}</h3>

          {!showPayment ? (
            <button onClick={handlePay}>
              Pay
            </button>
          ) : (
            <div className="payment-info">
              <p>
                Paypay ID: <strong>shinshashinsha7</strong>
              </p>
              <p>
                Paypal Email: <strong>molasisonfire@email.com</strong>
              </p>
              <p>
                After payment: <strong>pictures will be delivered in 3 days. Contact paypal email if still did not receive yet.</strong>
              </p>
              <img src={paylogo} alt="PayPay QR Code" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default App;
